import './App.css';
import {Route, Routes} from "react-router-dom";
import Layout from "./components/layout/Layout";
import Library from "./views/library/Library";
import Book from "./components/book/Book";
import Search from './views/search/Search';
import { useDispatch } from 'react-redux';
import { useAuthUserMutation } from './api/AuthApi/authService';
import { useLazyGetUserViewQuery } from './api/UserApi/userService';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import Cookies from 'universal-cookie';
import { setActiveRole, setName, setUser } from './store/reducers/userSlice';
import { setCredentials, setIsAuth } from './store/reducers/authSlice';
import { setIsError } from './store/reducers/notificationSlice';
import i18n from './i18n';

function App() {
    const dispatch = useDispatch();
    const [authUser] = useAuthUserMutation();
    const [getUserInfo] = useLazyGetUserViewQuery();
    const {t} = useTranslation();
    useEffect(() => {
        const username = JSON.parse(localStorage.getItem('user'))?.username;
        const refresh_token = JSON.parse(localStorage.getItem('jwt_refresh'));
        const language = localStorage.getItem('i18nextLng');
        if(username && refresh_token){
            (async()=>{
                const cookies = new Cookies();
                const storedUser = JSON.parse(localStorage.getItem('user'))
                dispatch(setActiveRole(storedUser.activeRole))
                dispatch(setName({firstname: storedUser.firstname, lastname: storedUser.lastname}))
                dispatch(setIsAuth(true))
                await i18n.changeLanguage(language ? language : 'kz')
                const result = await authUser({ username, grant_type: 'refresh_token', refresh_token })
                if (result.error) {
                    console.error(result.error)
                    dispatch(setIsError(t(`general.models.serverErrors.auth.${result.error.data.error_code}`)))
                } else {
                    dispatch(setCredentials(result.data.access_token))
                    cookies.set('jwt_auth', result.data.access_token, { httpOnly: true });
                    const user = await getUserInfo({ username, role: result.data.roles[0] });
                    if (user.error) {
                        console.error(user.error);
                        dispatch(setIsError(t(`general.models.serverErrors.UView.${user.error.data.error_code}`)))
                    } else {
                        const isUserHasRole = user.data.user.roles.includes(storedUser.activeRole);
                        dispatch(setUser(user.data.user));
                        localStorage.setItem('user',JSON.stringify({...user.data.user, activeRole: isUserHasRole ? storedUser.activeRole : user.data.user.roles[0]}))
                        dispatch(setActiveRole(isUserHasRole ? storedUser.activeRole : user.data.user.roles[0]));
                    }
                }

            })()
        }
    }, [authUser, dispatch, getUserInfo]);
  return (
      <div>
        <Routes>
            <Route path="/" element={<Layout/>}>
                <Route index element={<Library/>}/>
                <Route path="library" element={<Library/>}/>
                <Route path="library/:id" element={<Book/>}/>
                <Route path="search" element={<Search/>}/>
                <Route path="*" element={<Library/>}/>
            </Route>
        </Routes>
      </div>
  );
}

export default App;
